export function currencyDigits(currency:string):number{return new Intl.NumberFormat("ru-RU",{style:"currency",currency}).resolvedOptions().maximumFractionDigits??2;}
export function formatMinor(amountMinor:number|string,currency:string):string{
  if(typeof amountMinor==="number"&&!Number.isSafeInteger(amountMinor))throw new Error("unsafe_minor_amount");
  const minor=BigInt(amountMinor);
  const digits=currencyDigits(currency);
  const scale=10n**BigInt(digits);
  const absolute=minor<0n?-minor:minor;
  const parts=new Intl.NumberFormat("ru-RU",{style:"currency",currency,minimumFractionDigits:digits,maximumFractionDigits:digits}).formatToParts(absolute/scale);
  return `${minor<0n?"−":""}${parts.map(part=>part.type==="fraction"?(absolute%scale).toString().padStart(digits,"0"):part.value).join("")}`;
}
